var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button fab",class:("fab__" + _vm.size),on:{"click":_vm.onClick}},[_c('i',{staticClass:"material-icons",domProps:{"textContent":_vm._s(_vm.icon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }